import React from "react"
import { Button } from "reactstrap"

export default function NewEditReviews(props) {
  let { editReview } = props

  return (
    <div
      className="review-simple-container review-rcf-sub"
    >
      <div className="review-sub-simple-popup">
        <div className="popup-content my-submit-popup">
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", }}>
            <h3 className="review-text-heading1">
              Review Updated Successfully!
            </h3>
            <p className="review-simple-highlight review-text-submit" style={{width: "70%"}}>
                Thank you for taking the time to share your updated feedback.
            </p>
          </div>
          <div className="submit-btn-rcf-main-div-cont align-items-center">
            <Button
              className="rcf-submit-btn-sub2"
              onClick={() => {
                window.location.href = `https://${editReview?.merchantId}`;
              }}
            >
              Visit Store
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
